import React, { useState } from 'react';
import { authAPI } from '../api';
import { t } from '../i18n';

const EmailVerificationPrompt = () => {
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);

  const handleResend = async () => {
    setSending(true);
    setMessage('');
    try {
      await authAPI.sendVerification();
      setMessage(t('verificationEmailSent'));
    } catch (err) {
      setMessage(t('verificationEmailFailed'));
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="container" style={{ maxWidth: 600, margin: '60px auto', textAlign: 'center' }}>
      <div className="card" style={{ padding: 40 }}>
        <h1>{t('verifyYourEmail')}</h1>
        <p style={{ fontSize: 16, marginTop: 20, marginBottom: 30 }}>
          {t('verifyEmailInstructions')}
        </p>
        <button
          className="btn btn-primary"
          onClick={handleResend}
          disabled={sending}
          style={{ fontSize: 16, padding: '12px 24px' }}
        >
          {sending ? t('sending') : t('resendVerificationEmail')}
        </button>
        {message && (
          <div style={{ marginTop: 20, color: message === t('verificationEmailSent') ? 'green' : 'red', fontSize: 14 }}>
            {message}
          </div>
        )}
      </div>
    </div>
  );
};

export default EmailVerificationPrompt;